import { useSwrData } from './swrWrapper';

export const useFetchProducts = (type = "") => {
	const url = `${import.meta.env.VITE_APP_API_URL}/shopify/products?type=${type}`;
	const data = useSwrData(url, null);
	return data;
};
